
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terraform-modules",
      function () {
        return require("private-next-pages/terraform-modules/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terraform-modules"])
      });
    }
  